import { Amplify, Auth, Storage, API } from 'aws-amplify';
import awsconfig from '../aws-exports';

import Cards from './cards';
import Commons from './commons';
import Migration from './migration';
import Settings from './settings';
import ProApi from './pro-api';

/**
 * Before anything gets ahold of these services, let's make sure we're
 * all configured and ready to go.
 */
Amplify.configure(awsconfig);

const ConfigurationService = require('../config');

export const ProFeatures = new ProApi();

/**
 * Unused? Legacy?
 */
export const Users = {
	getDeckIndex: () => [],
	getDecks: () => [],
	saveDecks: () => [],
	getDeck: () => [],
	saveDeck: () => [],
	removeDeck: () => [],
};


export const Configuration = ConfigurationService;

/**
 * AWS stuff.
 */
export {
	Auth,
	Storage
};

/**
 * Our stuff.
 */
export {
	Cards,
	Commons,
	Migration,
	Settings
};

/**
 * for debug play
 */

// global.Auth = Auth;
// global.Migration = Migration;
// global.Settings = Settings;
global.Cards = Cards;
